import { Box } from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";
import { SelfCollectionModalCard } from "./self-collection-modal-card.component";

export const SelfCollectionOrderPlacedPage = () => {
  usePageViewAnalytics({ screen_name: "Self Collection Order Placed" });
  const { formatMessage } = useIntl();

  useDocumentTitle(formatMessage({ id: "STR_SELF_COLLECTION_ORDER_PLACED" }));

  return (
    <SelfCollectionModalCard>
      <Box css={{ "& img": { width: "128px", height: "auto" } }}>
        <Masonry
          rootNodeId={MASONRY.ROOT_NODE_ID_SELF_COLLECTION_ORDER_PLACED}
        />
      </Box>
    </SelfCollectionModalCard>
  );
};
